import { apiCall } from "./service";
import { URL_SKILLS, URL_SEARCH_SKILLS } from "./URL";

export const api = {
  getSkillsRequest(params) {
    return apiCall.get({
      url: `${URL_SKILLS}?loadAll=true`,
      isAuthToken: true,
    });
  },

  searchSkillsRequest(searchTerm) {
    return apiCall.get({
      url: `${URL_SEARCH_SKILLS}${searchTerm || ""}`,
      isAuthToken: true,
    });
  },

  createSkillRequest(name) {
    return apiCall.post({
      url: `${URL_SKILLS}`,
      isAuthToken: true,
      params: { name },
    });
  },

  getSkillUsageRequest(id) {
    return apiCall.get({
      url: `${URL_SKILLS}/${id}/usage`,
      isAuthToken: true,
    });
  },

  renameSkillRequest(id, name) {
    return apiCall.put({
      url: `${URL_SKILLS}/${id}`,
      isAuthToken: true,
      params: { name },
    });
  },

  deleteSkillRequest(id) {
    return apiCall.delete({
      url: `${URL_SKILLS}/${id}`,
      isAuthToken: true,
    });
  },
};

export default api;
